import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";
import util from "@/mixins/util";

const Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            profile: [], // 프로필 이미지
            mb_introduce: '', // 프로필 소개
            mb_id: '', // 회원 아이디
            idDoubleCheck: false, // 아이디 중복 확인 체크
            idDouble: false, // 아이디 중복
            mb_name: '', // 회원 이름

            mb_nick: '', // 닉네임
            nickDoubleCheck: false,
            nickDouble: false,

            mb_sex: '', // 회원 성별
            mb_birth: '', // 회원 생년월일
            mb_age: '', // 회원 나이
            mb_is_testor : '', // 회원 등급
            mb_height: '', // 키
            mb_weight: '', // 몸무게
            mb_password: '', // 회원 비밀번호
            mb_password_chk: '', // 비밀번호 확인

            mb_part:{outer:1,top:1,inner:1,pants:1,shoes:1,acc:1}, // 각 파트별 쇼핑금액
            mb_color: [], //선호색상
            mb_face: 1, //얼굴형
            mb_skin: 1, //피부톤
            mb_job: 2, //직종
            mb_job_extra: '', //직종이 1인경우 입력값
            mb_mat_shoulder: 1, //착용감-어깨
            mb_mat_middle: 1, //착용감-배
            mb_mat_top: 1, //착용감-가슴 (남자만)
            mb_mat_bottom: 1, //착용감-힙 (남자만)
            mb_mat_waist: 1, //착용감-허리 (여자만)
            mb_mat_thigh: 1, //착용감-허벅지 (여자만)
            mb_body: 1, //체형

            mb_memo : '', // 상담 기록

            p_title : '', // 프로필 타이틀 이름
            p_is_display: 1, // 노출 상태
            profileOutline: [], // 프로필 테두리 사진

            mb_hp: '', // 관리자 연락처
            mb_email: '', // 관리자 이메일

            isSetOrderData: false,
            order_mb_name: '', // 주문자명
            order_mb_hp: '' // 주문자번호
        }
    },
    validators: {
        profile: function (value) {
            return Validator.value(value)
        },
        mb_introduce: function (value) {
            return Validator.value(value)
            .maxLength(60, '소개글은 60자 이내만 가능합니다.')
        },
        mb_id: function (value) {
            return Validator.value(value)
                .required('아이디를 입력해 주세요.')
                .email('이메일 형식으로 입력해 주세요.')
                .custom(() => {
                    if (this.idDouble) {
                        return '중복된 아이디입니다.';
                    }
                })
        },

        idDoubleCheck: function (value) {
            return Validator.value(value)
        },

        idDouble: function (value) {
            return Validator.value(value)
        },

        mb_name: function (value) {
            return Validator.value(value)
                .required('이름을 입력해 주세요.')
                .maxLength(5, '이름은 5자 이내만 가능합니다.')
                .regex('^[가-힣ㄱ-ㅎㅏ-ㅣ]*$', '이름은 한글만 가능합니다.')
        },

        mb_nick: function (value) {
            return Validator.value(value)
                .required('닉네임을 입력해 주세요.')
                .custom(() => {
                    if (this.nickDouble) {
                        return '중복된 닉네임입니다.';
                    }
                })
        },

        nickDoubleCheck: function (value) {
            return Validator.value(value)
        },

        nickDouble: function (value) {
            return Validator.value(value)
        },

        mb_sex: function (value) {
            return Validator.value(value)
                .required('성별을 입력해 주세요.')
        },


        mb_birth: function (value) {
            return Validator.value(value)
                .required('생년월일을 입력해 주세요.')
                .regex(/^\d{4}-\d{2}-\d{2}$/).custom(() => {
                    const today = new Date();
                    const birthDate = new Date(value);
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                      age--;
                    }
                    if ( age < 14) {
                        return '만 14세 이상부터 등록이 가능합니다.';
                    }
                })
        },

        mb_age: function (value) {
            return Validator.value(value)
                .required('연령을 입력해 주세요.')
                .integer('숫자만 입력해 주세요.')
        },

        mb_is_testor: function (value) {
            return Validator.value(value)
                .required('회원 등급을 입력해 주세요.')
        },

        mb_height: function (value) {
            return Validator.value(value)
                .required('키를 입력해 주세요.')
                .integer('숫자만 입력해 주세요.')
        },
        mb_weight: function(value){
            return Validator.value(value)
            .required('몸무게를 입력해 주세요.')
            .integer('숫자만 입력해 주세요.')
        },
        mb_password: function (value) {
            return Validator.value(value)
                // .required('비밀번호를 입력해 주세요.')
                .minLength(8, '비밀번호는 8자 이상으로 입력해 주세요.')
                .regex(/(?=.*?[a-z])(?=.*?[A-Z])/ , '비밀번호는 영문 대소문자를 포함해 주세요.')
        },

        mb_password_chk: function (value) {
            return Validator.value(value)
                // .required('비밀번호 확인을 입력해 주세요.')
                .custom(() => {
                    if(this.mb_password !== value) {
                        return '비밀번호와 같지 않습니다.'
                    }
                })
        },

        mb_part: function(value) {
            return Validator.value(value)
                .required('평균 쇼핑 금액을 선택해 주세요.')
                // .greaterThanOrEqualTo(0, '평균 쇼핑 금액을 선택해주세요.')
                .custom(
                    () => {
                        if(value.outer === 0) {
                            return 'Outer의 쇼핑 금액을 선택해 주세요.'
                        }
                        else if(value.top === 0) {
                            return 'Top의 쇼핑 금액을 선택해 주세요.'
                        }
                        else if(value.inner === 0) {
                            return 'Inner의 쇼핑 금액을 선택해 주세요.'
                        }
                        else if(value.pants === 0) {
                            return 'Pants의 쇼핑 금액을 선택해 주세요.'
                        }
                        else if(value.shoes === 0) {
                            return 'Shoes의 쇼핑 금액을 선택해 주세요.'
                        }
                        else if(value.acc === 0) {
                            return 'Acc의 쇼핑 금액을 선택해 주세요.'
                        }
                    }
                )
        },
        mb_color: function(value) {
            return Validator.value(value)
                .required('선호하는 색상을 선택해주세요.')
                .greaterThanOrEqualTo(1, '선호하는 색상을 선택해주세요.')
                .custom(
                    () => {
                        if(value.length === 0) {
                            return '선호하는 색상을 선택해 주세요.'
                        }
                        else if(value.length >3){
                            return '색상은 세개까지 선택 가능 합니다.'
                        }
                    }
                )
        },
        mb_face: function(value) {
            return Validator.value(value)
                // .required('얼굴형을 선택해주세요.')
                // .greaterThanOrEqualTo(1, '얼굴형을 선택해 주세요.')
        },
        mb_skin: function(value) {
            return Validator.value(value)
                // .required('피부톤을 선택해주세요.')
                // .greaterThanOrEqualTo(1, '피부톤을 선택해 주세요.')
        },
        mb_job: function(value) {
            return Validator.value(value)
                // .required('직종을 선택해주세요.')
                // .greaterThanOrEqualTo(1, '직종을 선택해 주세요.')
        },
        mb_job_extra: function(value) {
            return Validator.value(value)
                // .required('직종을 적어 주세요.');
                .custom(() => {
                    /*if(this.mb_job === 1 && util.isEmpty(value)) {
                        return '직종을 적어 주세요.';
                    }*/
                })
        },
        mb_mat_shoulder: function(value) {
            return Validator.value(value)
                // .required('어깨에 대한 착용감을 선택해 주세요.')
        },
        mb_mat_middle: function(value) {
            return Validator.value(value)
                // .required('배에 대한 착용감을 선택해 주세요.')
        },
        mb_mat_top: function(value) {
            return Validator.value(value)
                // .required('가슴에 대한 착용감을 선택해 주세요.')
        },
        mb_mat_bottom: function(value) {
            return Validator.value(value)
                // .required('힙에 대한 착용감을 선택해 주세요.')
        },
        mb_mat_waist: function(value) {
            return Validator.value(value)
                // .required('허리에 대한 착용감을 선택해 주세요.')
        },
        mb_mat_thigh: function(value) {
            return Validator.value(value)
                // .required('허벅지에 대한 착용감을 선택해 주세요.')
        },
        mb_body: function (value) {
            return Validator.value(value)
        },
        mb_memo: function (value) {
            return Validator.value(value)
        },

        p_title: function (value) {
            return Validator.value(value)
                .required('이름을 입력해 주세요.')
        },

        p_is_display: function (value) {
            return Validator.value(value)
        },

        profileOutline: function (value) {
            return Validator.value(value)
                .required('이미지를 등록해 주세요.')
        },

        mb_hp: function (value) {
            return Validator.value(value)
            .required('전화번호를 입력하세요.')
            .minLength(10, '전화번호를 입력해 주세요.(숫자만)')
            .regex('^[0-9|]+$', '전화번호 형식이 잘못됐습니다.(숫자만)')
        },

        mb_email: function (value) {
            return Validator.value(value)
                .email('이메일 형식으로 입력해 주세요.')
        },

        order_mb_name: function (value) {
            return Validator.value(value)
                .maxLength(5, '이름은 5자 이내만 가능합니다.')
                .custom(() => {
                    const regex = /^[ㄱ-ㅎ|가-힣|]+$/;
                    if(this.isSetOrderData && util.isEmpty(value)) {
                        return '이름을 입력해 주세요.'
                    }
                    if(this.isSetOrderData && !regex.test(value)) {
                        return '이름은 한글만 가능합니다.'
                    }
                })
                // .required('이름을 입력해 주세요.')
                // .regex('^[가-힣ㄱ-ㅎㅏ-ㅣ]*$', '이름은 한글만 가능합니다.')
        },
        order_mb_hp: function (value) {
            return Validator.value(value)
                .minLength(10, '전화번호를 입력해 주세요.(숫자만)')
                .custom(() => {
                    const regex = /^[0-9|]+$/;
                    if(this.isSetOrderData && util.isEmpty(value)) {
                        return '이름을 입력해 주세요.'
                    }
                    if(this.isSetOrderData && !regex.test(value)) {
                        return '전화번호 형식이 잘못됐습니다.(숫자만)'
                    }
                })
            // .required('전화번호를 입력하세요.')
            // .minLength(10, '전화번호를 입력해 주세요.(숫자만)')
            // .regex('^[0-9|]+$', '전화번호 형식이 잘못됐습니다.(숫자만)')
        },
    },
    methods: {
        checkIdDouble(keyName = 'mb_id', value) {
            if (this.idDoubleCheck) {
                return false;
            }

            this.$validate([keyName]).then(success => {
                if (!success) {
                    return false;
                }

                let params = {
                    m_type: 'normal',
                    mb_id: value,
                }
                try {
                    this.$api.$member.checkIdDouble(params).then(res => res.Data.Result).then(res => {
                        let type = res.Info.Type;
                        this.checkIdAfter(keyName, type);
                    })
                } catch (e) {
                    console.log((e));
                }
            })
        },

        checkIdAfter(keyName = 'mb_id', type) {
            if (type === 1) {
                this.idDoubleCheck = true;
                this.idDouble = false;
            } else {
                this.idDoubleCheck = false;
                this.idDouble = true;
            }
            this.$validate([keyName]);
        },

        checkNickDouble(keyName = 'mb_nick', value) {
            if (this.nickDoubleCheck) {
                return false;
            }

            this.$validate([keyName]).then(success => {
                if (!success) {
                    return false;
                }

                let params = {
                    m_type: 'normal',
                    mb_nick: value,
                }
                try {
                    this.$api.$member.checkNickDouble(params).then(res => res.Data.Result).then(res => {
                        let type = res.Info.Type;
                        this.checkNickAfter(keyName, type);
                    })
                } catch (e) {
                    console.log((e));
                }
            })
        },

        checkNickAfter(keyName = 'mb_nick', type) {
            if (type === 1) {
                this.nickDoubleCheck = true;
                this.nickDouble = false;
            } else {
                this.nickDoubleCheck = false;
                this.nickDouble = true;
            }
            this.$validate([keyName]);
        },

    },
    computed: {}
}
